import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ActiveAlerts from "../../components/notification/ActiveAlerts";
import NotificationSettings from "../../components/notification/NotificationSettings";

const NotifSettings = () => {
	const navigate = useNavigate();

	return (
		<div className="px-2 py-4 mb-20 mt-10">
			<div className="max-w-md mx-auto p-2">
				<div className="flex justify-between items-center mb-4">
					<button
						type="button"
						onClick={() => navigate("/")}
						className="p-2 text-gray-700 rounded-full"
						aria-label="Back"
					>
						<ChevronLeft className="w-5 h-5 text-black" />
					</button>

					<h1 className="text-xl font-semibold text-gray-900">
						Paramètres de notification
					</h1>

					<div className="w-8" />
				</div>
			</div>
			<div className="max-w-md mx-auto px-2 space-y-4">
				<ActiveAlerts />
				<NotificationSettings />
			</div>
		</div>
	);
};

export default NotifSettings;
